import { showOverlayConstants } from '../constants';

const initialState = {};

export const showOverlay = (
  state = initialState,
  action: { type: string; payload: any },
) => {
  switch (action.type) {
    case showOverlayConstants.SHOW_OVERLAY:
      return {
        ...state,
        [action.payload.overlayName]: action.payload.props || true,
      };
    case showOverlayConstants.CLOSE_OVERLAY:
      return {
        ...state,
        [action.payload.overlayName]: false,
      };
    case showOverlayConstants.CLOSE_ALL_OVERLAY:
      return {};
    default:
      return state;
  }
};
